const state = {
    yieldStatisticsDataFields: [
        {
            key: "date",
            label: "日期",
            sortable: true,
        },
        {
            key: "placeItem",
            label: "廠區",
            sortable: true,
        },
        {
            key: "groupItem",
            label: "組別",
            sortable: true,
        },
        {
            key: "classItem",
            label: "班別",
            sortable: true,
        },
        {
            key: "device",
            label: "機台",
            sortable: true,
        },
        {
            key: "qty",
            label: "產量",
            sortable: true,
        }
    ],
    yieldStatisticsDataItem: []
}
const getters = {
    get_yieldStatisticsDataFields: state => {
        return state.yieldStatisticsDataFields
    },
    get_yieldStatisticsDataItem: state => {
        return state.yieldStatisticsDataItem
    }
}
const actions = {
    set_yieldStatisticsDataFields(context, array) {
        context.commit('SET_YIELDSTATISTICSDATAFIELDS', array);
    },
    set_yieldStatisticsDataItem(context, array) {
        context.commit('SET_YIELDSTATISTICSDATAITEM', array);
    }
}
const mutations = {
    SET_YIELDSTATISTICSDATAFIELDS(state, array) {
        state.yieldStatisticsDataItem = array;
    },
    SET_YIELDSTATISTICSDATAITEM(state, array) {
        state.yieldStatisticsDataItem = array;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/yieldStatisticsData.js